/**
 * SingleSelectOption
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
/** SingleSelect option. */
var SingleSelectOption = function (_a) {
    var text = _a.text, value = _a.value, onChange = _a.onChange, className = _a.className, htmlAttributes = __rest(_a, ["text", "value", "onChange", "className"]);
    return (React.createElement("button", __assign({ className: clsx(className, 'px-3 py-2 w-full text-left hover:bg-greyLight'), value: value, onClick: function () {
            onChange && onChange();
        } }, htmlAttributes), text));
};
export default SingleSelectOption;
